export default [
  {
    path: '/blockchain_network',
    name: 'NetworkView',
    component: () =>
      import(
        /* webpackChunkName: "settings" */ '@/views/Settings/NetworkView.vue'
      ),
    meta: { title: 'Blockchain Network', group: 'settings' },
  },
  {
    path: '/user_registration',
    name: 'AccountView',
    component: () =>
      import(
        /* webpackChunkName: "settings" */ '@/views/Settings/AccountView.vue'
      ),
    meta: { title: 'User Registration', group: 'settings' },
  },
  {
    path: '/api-keys',
    name: 'APIKeysView',
    component: () =>
      import(
        /* webpackChunkName: "settings" */ '@/views/Settings/APIKeysView.vue'
      ),
    meta: { title: 'API Keys', group: 'settings' },
  },
  {
    path: '/system_wallet',
    name: 'SystemWalletView',
    component: () =>
      import(
        /* webpackChunkName: "settings" */ '@/views/Settings/SystemWalletView.vue'
      ),
    meta: { title: 'System Wallet', group: 'settings' },
  },
  {
    path: '/group_management',
    name: 'GroupView',
    component: () =>
      import(
        /* webpackChunkName: "settings" */ '@/views/Settings/GroupView.vue'
      ),
    meta: {
      title: 'Group Management',
      group: 'settings',
      requiresRole: ['SUPER_ADMIN', 'ADMIN'],
    },
  },
  {
    path: '/role_management',
    name: 'RoleView',
    component: () =>
      import(
        /* webpackChunkName: "settings" */ '@/views/Settings/RoleView.vue'
      ),
    meta: {
      title: 'Role Management',
      group: 'settings',
      requiresRole: ['SUPER_ADMIN', 'ADMIN'],
    },
  },
  {
    path: '/permission_management',
    name: 'PermissionCodeView',
    component: () =>
      import(
        /* webpackChunkName: "settings" */ '@/views/Settings/PermissionCodeView.vue'
      ),
    meta: {
      title: 'Permission Management',
      group: 'settings',
      requiresRole: ['SUPER_ADMIN', 'ADMIN'],
    },
  },
]
